import { useEffect, useState } from "react";
import { toast } from "sonner";

const STATUSES = ["new", "contacted", "quoted", "closed"];

export function EnquiriesTable({ http, fail }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    http.get("/admin/enquiries").then((r) => setItems(r.data)).catch(fail);
  }, [http, fail]);
  const setStatus = async (id, status) => {
    try {
      const r = await http.put(`/admin/enquiries/${id}`, { status });
      setItems((list) => list.map((x) => (x.enquiry_id === id ? r.data : x)));
      toast.success(`Request ${id} marked ${status}`);
    } catch (e) {
      fail(e);
    }
  };
  return (
    <section className="admin-section" data-testid="admin-enquiries">
      <h2>
        Tyre requests <i>{items.length}</i>
      </h2>
      {!items.length ? (
        <p className="admin-empty" data-testid="admin-enquiries-empty">No tyre requests yet.</p>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Request</th>
                <th>Customer</th>
                <th>Tyre</th>
                <th>Requirements</th>
                <th>Email alert</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x) => (
                <tr key={x.enquiry_id} data-testid={`admin-enquiry-row-${x.enquiry_id}`}>
                  <td>
                    <b>{x.enquiry_id}</b>
                    <span>{new Date(x.created_at).toLocaleString()}</span>
                  </td>
                  <td>
                    <b>{x.name}</b>
                    <span>
                      <a href={`mailto:${x.email}`}>{x.email}</a>
                      {x.phone && ` · ${x.phone}`}
                    </span>
                  </td>
                  <td>
                    <b>
                      {x.tyre_size} × {x.quantity}
                    </b>
                    <span>{[x.brand_model, x.vehicle].filter(Boolean).join(" · ") || "—"}</span>
                  </td>
                  <td>
                    <span className="enquiry-notes">{x.notes || "—"}</span>
                  </td>
                  <td>
                    <span className={`pay-pill ${x.email_status === "sent" ? "paid" : x.email_status === "failed" ? "failed" : ""}`} data-testid={`admin-enquiry-email-${x.enquiry_id}`}>
                      {x.email_status}
                    </span>
                  </td>
                  <td>
                    <select value={x.status} onChange={(e) => setStatus(x.enquiry_id, e.target.value)} data-testid={`admin-enquiry-status-${x.enquiry_id}`}>
                      {STATUSES.map((s) => (
                        <option key={s}>{s}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
